<template>
  <div class="wrapper">
    <parralax class="page-header header-filter">
      <ul>
        <li>Vue 2.5.17</li>
        <li>Axios, Element UI, VeeValidate, Vue i18n, Router, Vuex</li>
        <li>ESLint, PWA</li>
      </ul>
    </parralax>
    <div class="main">
      <h2>sup</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "ICO",
  components: {},
};
</script>

<style lang="scss" scoped></style>
